import "./Moulding.css";
import moulding from "../../../assets/moudling.png";
import { TypeAnimation } from "react-type-animation";
import CallbackPopup from "../../../components/common/CallbackPopup";
import { useState } from "react";
function Moulding() {
  const [popupOpen, setPopupOpen] = useState(false);

  return (
    <div className="moulding-container">
      <div className="welcome-text-container">
        {/* <span className="">You will always find</span> */}
        <h1 className="">
          <TypeAnimation
            sequence={["Quality", 3000, "Excellence", 3000, "Innovation", 3000]}
            wrapper="span"
            speed={10}
            style={{ fontSize: "1.2em", display: "inline-block" }}
            repeat={Infinity}
          />
        </h1>

        <span className="">in everything we do.</span>
      </div>
      {/* <div className="description-container">
        <h6>
          We transform visions into reality with innovative infrastructure
          solutions for homes and commercial projects
        </h6>
      </div> */}
      <div className="button-container">
        <button onClick={() => setPopupOpen(true)} className="button">
          <span class="button__icon-wrapper">
            <svg
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="button__icon-svg"
              width="10"
            >
              <path
                d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                fill="currentColor"
              ></path>
            </svg>

            <svg
              viewBox="0 0 14 15"
              fill="none"
              width="10"
              xmlns="http://www.w3.org/2000/svg"
              class="button__icon-svg button__icon-svg--copy"
            >
              <path
                d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                fill="currentColor"
              ></path>
            </svg>
          </span>
          Get a Quote
        </button>
        <CallbackPopup open={popupOpen} setOpen={setPopupOpen} />
      </div>
    </div>
  );
}
export default Moulding;
